import { defineStore } from 'pinia'
import type { PromotionUser, PromotionUserState } from '~/composables/promotion/interface'

const defaultPromotionUser: PromotionUser = {
  plan: {},
  todayRefund: 0,
  yesterdayRefund: 0,
  totalRefund: 0,
  title: '',
  description: '',
  mappingKey: '',
  activedDate: '',
  remainDays: 0,
  turnover: 0,
  rolling: 0,
  calculated_turnover: 0,
  multiplier: 0,
  deposit_amount: 0,
  promotion_amount: 0
}
const STORE_NAME = 'USER_PROMOTION_STORE'

export const usePromotionUserStore = defineStore(STORE_NAME, {
  state: (): PromotionUserState => ({
    promotionUser: { ...defaultPromotionUser }
  }),
  persist: true,
  actions: {
    setPromotionUser(data: PromotionUser) {
      this.promotionUser = data
      this.promotionUser.yesterdayRefund = data.yesterday_refund
      this.promotionUser.totalRefund = data.total_refund
    }
  }
})
